import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Config } from "constant";
import Button from "module-common/Button";
import Modal from "module-common/Modal";
import Icon from "module-common/Icon";

export default class AddModal extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    onClose: PropTypes.func
  };

  render() {
    return (
      <Modal>
        <Wrapper>
          <Text>Connect Your Social Media Account</Text>
          <Buttons>
            <Button width={328} height={38} semiRounded forcedColor="facebook" onClick={() => this.onClick("facebook")}>
              <ButtonContent>
                <ChannelLogo src={require("img/nolimit/facebook-button-logo.png")} />
                <ButtonText>
                  Login with Facebook
                </ButtonText>   
              </ButtonContent>              
            </Button>
            <Button width={328} height={38} semiRounded forcedColor="twitter" onClick={() => this.onClick("twitter")}>
              <ButtonContent>
                <ChannelLogo src={require("img/nolimit/twitter-button-logo.png")} />
                <ButtonText>
                  Login with Twitter
                </ButtonText>
              </ButtonContent>              
            </Button>
            <Button width={328} height={38} semiRounded forcedColor="instagram" onClick={() => this.onClick("instagram")}>
              <ButtonContent>
                <ChannelLogo src={require("img/nolimit/instagram-button-logo.png")} />
                <ButtonText>
                  Login with Instagram
                </ButtonText>
              </ButtonContent>              
            </Button>
            <Button width={328} height={38} semiRounded forcedColor="line" onClick={() => this.onClick("line")}>
              <ButtonContent>
                <ChannelLogo src={require("img/nolimit/line-button-logo.png")} />
                <ButtonText>
                  Login with LINE
                </ButtonText>
              </ButtonContent>              
            </Button>
            <Button width={328} height={38} semiRounded forcedColor="liveChat" onClick={() => this.onClick("livechat")}>
              <ButtonContent>
                <ChannelLogo src={require("img/nolimit/livechat-button-logo.png")} />
                <ButtonText>
                  Login with LiveChat
                </ButtonText>
              </ButtonContent>              
            </Button>
          </Buttons>
          <XIcon
            name="x-button-blue"
            mode="contain"
            width={30}
            height={30}
            onClick={this.props.onClose}
          />
        </Wrapper>
      </Modal>
    );
  }

  onClick(channel) {
    const onClick = this.props.onClick;
    if (onClick) onClick(channel);

    const origin = window.location.origin;
    let link;
    switch (channel) {
      case "facebook":
        link = `${
          Config.apiUrl
        }/authorize/social_media/facebook?redirect_uri=${origin}/supervisor-setting/account`;
        window.open(link, "_self");
        break;
      case "twitter":
        link = `${
          Config.apiUrl
        }/authorize/social_media/twitter?redirect_uri=${origin}/supervisor-setting/account`;
        window.open(link, "_self");
        break;
      case "instagram":
        link = `${
          Config.apiUrl
        }/authorize/social_media/instagram?redirect_uri=${origin}/supervisor-setting/account`;
        window.open(link, "_self");
        break;
      default:
        break;
    }
  }
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 550px;
  justify-content: space-around;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 10px;
`;
const ButtonContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`

const ButtonText = styled.div`
  margin-left: 26px;
  font-size: 18px;
  line-height: 21px;
  color: white;
  text-align: center;
`
const ChannelLogo = styled.img`
  margin-left: 20px;
  width: 20px;
  height: 20px;
  object-fit: contain;
`
const Buttons = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
  flex-direction: column;
  align-items: center;
  height: 250px;
`;
const XIcon = styled(Icon)`
  position: absolute;
  top: -15px;
  right: -15px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/channel-panel/AddModal.js